export default {
  title: 'Usuários',
  invite_button: 'Convidar',
  load_failed: 'Não foi possível carregar os usuários.',
  retry_hint: 'Tente novamente em instantes.',
  you: '(você)',
  since: 'desde {date}',
  role_aria: 'Papel do membro',
  remove: 'Remover',
  remove_confirm: 'Remover {name} da conta?',
  remove_failed: 'Falha ao remover o membro.',
  role_failed: 'Falha ao alterar o papel.',
  pending_invites: 'Convites pendentes ({count})',
  no_pending: 'Nenhum convite aguardando aceite.',
  invite_expired: 'Expirado',
  invite_pending: 'Pendente',
  invite_expiry_expired: 'expirado',
  invite_expiry_today: 'expira em menos de 1 dia',
  invite_expiry_days: 'expira em {count} dias',
  revoke_invite: 'Revogar',
  revoke_invite_failed: 'Falha ao revogar o convite.',
  modal_aria: 'Convidar usuário',
  modal_title_new: 'Convidar para a conta',
  modal_title_done: 'Convite criado',
  modal_done_body: 'Envie este link para {email} — ele precisa entrar na LOCZI com esse e-mail para aceitar. O convite vale por 7 dias.',
  invite_url_aria: 'URL do convite',
  invite_only_email: 'O convite só funciona para quem entrar com {email}.',
  guest_email_label: 'E-mail do convidado',
  guest_email_placeholder: 'pessoa@empresa.com',
  role_label: 'Papel na conta',
  role_basic_desc: 'Vê apenas os dispositivos liberados.',
  role_admin_desc: 'Gerencia dispositivos, grupos e cercas.',
  create_failed: 'Não foi possível criar o convite.',
  generate: 'Gerar convite',
}
